import CancelButton, { CancelButtonTemplate } from './CancelButton';

export default CancelButton;
export { CancelButtonTemplate };
